import React, { useState } from 'react';

import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import { useMutationForgotPassword } from 'api/mutations/forgotPassword.mutation';

import { NewButton } from 'components/common/CustomizeButton/newButton';

import classes from 'components/App/AuthPublicPages/ForgotPassword/forgotPassword.module.scss';
import Layout from 'components/App/AuthPublicPages/_common/publicLayout/layout';
import { CustomizedFormErrorMessage } from 'components/common';

interface IForgotPasswordForm {
    email: string;
}

export const ForgotPassword = () => {
    const [message, setMessage] = useState<string>('');
    const [error, setError] = useState<string>('');
    const { mutate } = useMutationForgotPassword();
    const [loading, setLoading] = useState<boolean>(false);
    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm<IForgotPasswordForm>({
        defaultValues: {
            email: '',
        },
    });

    const handleSaveUseForm = (value) => {
        setLoading(true);
        mutate(
            { email: value.email },
            {
                onSuccess: () => {
                    setMessage(
                        `If an account exists matching the email address you provided (${value.email}), then you will receive an email with instructions on how to reset your password.`,
                    );
                },
                onError: (error) => {
                    setError(error?.response?.data || 'Something went wrong');
                },
                onSettled: () => {
                    setLoading(false);
                },
            },
        );
    };

    return (
        <Layout>
            <div className={classes.loginFormWrapper}>
                <div className={classes.loginFormTitleWrapper}>
                    {message === '' ? 'Forgot your password?' : 'Check your e-mail'}
                </div>
                <div className={classes.loginFormSubTitle}>
                    {message === '' ? (
                        <>Enter your email and we'll send you a link to get back into your account.</>
                    ) : (
                        message
                    )}
                </div>

                <form onSubmit={handleSubmit(handleSaveUseForm)} autoComplete={'off'}>
                    <div className={classes.formWrapper}>
                        {message === '' && (
                            <div className={classes.inputsContainer}>
                                <div className={classes.inputWrapper}>
                                    <label>E-mail</label>
                                    <input
                                        className={`${errors.email ? classes.invalid : ''} ${classes.loginInput}`}
                                        placeholder={'Enter your E-mail'}
                                        {...register('email', {
                                            required: 'Email is Required',
                                            pattern: {
                                                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                message: 'You have entered an invalid email address!',
                                            },
                                        })}
                                    />
                                    {errors.email && <CustomizedFormErrorMessage text={errors.email.message} />}
                                    {error && <CustomizedFormErrorMessage text={error} />}
                                </div>
                            </div>
                        )}

                        <div className={classes.actionsWrapper}>
                            <NewButton
                                color={'login'}
                                variant={'contained'}
                                className={classes.submit}
                                disabled={loading}
                                loading={loading}
                                id={'login-button'}
                                type={'submit'}
                            >
                                {message === '' ? 'Send' : 'Resend e-mail'}
                            </NewButton>
                        </div>
                        <div className={classes.backToLoginLink}>
                            <Link to={'/login'}>Back to sign in</Link>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    );
};
